export default "__VITE_ASSET__D1pK5WkB__"